export default function ($rootScope, currentUser) {
    currentUser()
        .then(result => {
            $rootScope.isAdmin = result.isAdmin;
            $rootScope.isOperator = result.isOperator;
            $rootScope.isTeamLead = result.isTeamLead;
            $rootScope.isAccountAdmin = result.isAccountAdmin;
            $rootScope.isRrd = result.isRrd;

            $rootScope.doesUserHaveRoles = function (displayTo) {
                const display = result.roles.some(userRole => {
                    return displayTo.includes(userRole);
                });

                return display;
            };
        });
}



// WEBPACK FOOTER //
// ./Client/app/common/runtime/currentUserRole.js